import { Paper, styled } from '@mui/material';

export const ScheduleCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  height: '100%',
}));
